import { render, staticRenderFns } from "./sms-grid.vue?vue&type=template&id=6b0cc795&scoped=true"
import script from "./sms-grid.vue?vue&type=script&lang=js"
export * from "./sms-grid.vue?vue&type=script&lang=js"
import style0 from "./sms-grid.vue?vue&type=style&index=0&id=6b0cc795&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0cc795",
  null
  
)

export default component.exports